import {
  LayoutDashboard, FolderTree, Folders, Package, Users, UserCircle, MessageSquare,
  ClipboardList, Crown, BarChart3, Upload, Route, ScrollText, Settings, FileText,
  MapPin, ShieldCheck, Briefcase, CreditCard, Webhook, DatabaseBackup, Map, Building2,
} from 'lucide-react';

export const TABS = [
  { key: 'overview', label: 'Overview', icon: LayoutDashboard },
  { key: 'analytics', label: 'Analytics', icon: BarChart3, custom: true },
  {
    key: 'manage_category',
    label: 'Manage Category',
    icon: FolderTree,
    isGroup: true,
    children: [
      { key: 'main_categories', label: 'Main Categories', icon: FolderTree, resource: 'main_categories', fields: ['name','slug','image','order'] },
      { key: 'categories', label: 'Categories', icon: Folders, resource: 'categories', fields: ['name','slug','main_category_id','show_in_top','image','products_count','order'] },
      { key: 'sub_categories', label: 'Sub Categories', icon: ClipboardList, resource: 'sub_categories', fields: ['name','slug','category_id','image','order'] },
    ],
  },
  { key: 'products', label: 'Products', icon: Package, resource: 'products', fields: ['name','slug','price','unit','moq','image','sub_category_id','supplier_id','gst','description'] },
  { key: 'suppliers', label: 'Vendors', icon: Users, resource: 'suppliers', fields: ['vendor_code','name','mobile','email','city','claimed','established','gst','rating','response','employees','logo','status'] },
  { key: 'customers', label: 'Customers', icon: UserCircle, resource: 'customers', fields: ['customer_code','name','mobile','email','city','verified','customer_type','status','district'] },
  {
    key: 'locations',
    label: 'Locations',
    icon: Map,
    isGroup: true,
    children: [
      { key: 'districts', label: 'Districts', icon: Building2, resource: 'districts', fields: ['name','slug','state','order','is_active'] },
      { key: 'cities', label: 'Cities', icon: MapPin, resource: 'cities', fields: ['name','district','order','is_active'] },
    ],
  },
  { key: 'seller_types', label: 'Seller Types', icon: ShieldCheck, resource: 'seller_types', fields: ['name','slug','order','is_active','verified_only'] },
  { key: 'business_types', label: 'Business Types', icon: Briefcase, resource: 'business_types', fields: ['name','slug','order','is_active'] },
  { key: 'plans', label: 'Plans', icon: Crown, resource: 'plans', fields: ['name','slug','price','duration_days','color','tagline','order','max_products','max_categories','priority_listing','highlighted','features'] },
  { key: 'enquiries', label: 'Enquiries', icon: MessageSquare, viewOnly: true, fields: ['name','mobile','vendor_name','product_name','created_at','message'] },
  { key: 'requirements', label: 'Requirements', icon: ClipboardList, custom: true },
  { key: 'certificates', label: 'Certificates', icon: ShieldCheck, custom: true },
  { key: 'import', label: 'Bulk Import', icon: Upload, custom: true },
  { key: 'lead_rules', label: 'Lead Routing', icon: Route, custom: true },
  { key: 'audit_logs', label: 'Audit Log', icon: ScrollText, custom: true },
  { key: 'pages', label: 'Pages', icon: FileText, custom: true },
  { key: 'admin_users', label: 'Admin Users', icon: ShieldCheck, custom: true },
  { key: 'payments', label: 'Payments', icon: CreditCard, custom: true },
  { key: 'payment_events', label: 'Payment Events', icon: Webhook, custom: true },
  { key: 'backups', label: 'Backups', icon: DatabaseBackup, custom: true },
  { key: 'site_settings', label: 'Site Settings', icon: Settings, custom: true },
];

// Flat lookup of all tabs (including children) for tab resolution
export const FLAT_TABS = TABS.flatMap((t) => (t.isGroup ? t.children : [t]));
